import React, { createContext, useState, useContext, useEffect } from 'react';
import { useWallet as useSolanaWallet } from '@solana/wallet-adapter-react';

const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
    const [status, setStatus] = useState(false);
    const [formStatus, setFormStatus] = useState(false);
    const [registrationLocked, setRegistrationLocked] = useState(false);
    const [registeredEthAddress, setRegisteredEthAddress] = useState('');
    const [balance, setBalance] = useState(0);
    const { connected, publicKey } = useSolanaWallet();
    const connectedAddress = publicKey ? publicKey.toBase58() : '';

    useEffect(() => {
        if (!connected || !connectedAddress) {
            setStatus(false);
            setFormStatus(false);
            setRegistrationLocked(false);
            setRegisteredEthAddress('');
            setBalance(0);
        }
    }, [connected, connectedAddress]);

    return (
        <WalletContext.Provider value={{
            status,
            setStatus,
            connectedAddress,
            formStatus,
            setFormStatus,
            registrationLocked,
            setRegistrationLocked,
            registeredEthAddress,
            setRegisteredEthAddress,
            balance,
            setBalance,
            isConnected: Boolean(connected && connectedAddress)
        }}>
            {children}
        </WalletContext.Provider>
    );
};

export const useWallet = () => useContext(WalletContext);
